module.exports = __webpack_public_path__ + "img/1679989370404-1679989348880630515705689704219.jpg.a267c058.webp";